
import { defineComponent } from "@vue/runtime-core";
import ExtensionCard from "@/components/ExtensionCard.vue";

export default defineComponent({
  data: () => ({
    choosedGrade: 'Бакалавриат',
    choosedCard: -1,
    grades: [
      {
        name: "Бакалавриат",
        directions: [
          {
            name: "09.03.02 Информационные системы и технологии",
            budgetPlaces: 115,
            contractPlaces: '145 очная форма обучения / 25 очно-заочная форма обучения / 25 заочная форма обучения',
            programs: [
              "Большие данные и машинное обучение (очная форма)",
              "Компьютерные науки и технологии искусственного интеллекта (очная и заочная формы)",
              "Фуллстек разработка (очная и очно-заочная формы)",
              "Системная аналитика и разработка программного обеспечения (очная форма)"
            ],
            price: "Стоимость обучения в 2025 году без предоставления скидки: 347 000 руб. (очная форма)/ 100 000 руб. (заочная форма)/ 123 000 руб. (очно-заочная форма).",
            exams: [
              "Математика",
              "Информатика и ИКТ, физика",
              "Русский язык",
            ],
            spoExams: [
              "Информационные технологии",
              "Архитектура аппаратных средств",
              "Русский язык",
            ],
            discounts: [
              "от 190 баллов – 30%",
              "от 211 балла – 40%",
              "от 231 балла – 50%",
            ],
            perspective: "Благодаря полученным навыкам и компетенциям, выпускники могут работать специалистами интеллектуального анализа данных (Data Mining Specialists), инженерами данных (Data Engineers), разработчиками баз данных (Database Developers), программистами, системными аналитиками, бизнес- аналитиками (Business Analysts, BI Analysts), DevOps-инженерами, руководителями проектов, Web-разработчиками, фуллстек (Full Stack), фронтенд (Frontend) или бэкенд (Backend)- разработчиками.",
          },
          {
            name: "09.03.03 Прикладная информатика",
            budgetPlaces: 100,
            contractPlaces: 60,
            programs: [
              "Системы искусственного интеллекта",
              "Программные решения для бизнеса",
            ],
            price: "Стоимость обучения без предоставления скидки: 347 000 руб.",
            exams: [
              "Математика",
              "Информатика и ИКТ, физика",
              "Русский язык",
            ],
            spoExams: [
              "Информационные технологии",
              "Архитектура аппаратных средств",
              "Русский язык",
            ],
            discounts: [
              "от 190 баллов – 30%",
              "от 211 балла – 40%",
              "от 231 балла – 50%",
            ],
            perspective: "Выпускники данной могут претендовать на такие престижныепрофессии как менеджер проектов в области информационных технологий, аналитик бизнес-процессов, системный аналитик, бизнес-консультант по информационным технологиям, архитектор информационных систем, аналитик данных, специалист по машинному обучению, инженер по данным, дата-сайентист, инженер-исследователь, разработчик программного обеспечения.",
          },
          {
            name: "38.03.01 Экономика",
            budgetPlaces: 0,
            contractPlaces: "120 очная форма обучения / 60 очно-заочная форма обучения",
            programs: [
              "Бизнес-архитектура, учет и финансы (очная и очно-заочная формы)",
              "Экономика цифрового предприятия (очная и очно-заочная формы)",
              "Организация бизнес-процессов предприятия (очно-заочная форма)"
            ],
            price: "Стоимость обучения без предоставления скидки: 312 500 руб. (очная форма)/ 110 000 руб. (очно-заочная форма)",
            exams: [
              "Математика",
              "Обществознание или История или География или Информатика и ИКТ или Иностранный язык (английский)",
              "Русский язык",
            ],
            spoExams: ["Экономика организации", "Менеджмент", "Русский язык"],
            discounts: [
              "от 190 баллов – 30%",
              "от 211 балла – 40%",
              "от 231 балла – 50%",
            ],
            perspective: "Профессиональная деятельность выпускника возможна в экономических, финансовых, маркетинговых, производственно- экономических и аналитических службах организаций различных отраслей (в том числе и в аграрном секторе экономики), сферах и формах собственности, кредитных и страховых учреждениях, органах государственной и муниципальной власти, академических и ведомственных научно-исследовательских организациях, учреждениях высшего профессионального образования.",
          },
          {
            name: "38.03.02 Менеджмент",
            budgetPlaces: 0,
            contractPlaces: 60,
            programs: [
              "Бизнес-логистика и маркетинг",
              "Управление бизнесом",
            ],
            price: "Стоимость обучения без предоставления скидки: 312 500 руб.",
            exams: [
              "Математика",
              "Обществознание или История или Информатика и ИКТ или Иностранный язык (английский)",
              "Русский язык",
            ],
            spoExams: ["Экономика организации", "Менеджмент", "Русский язык"],
            discounts: [
              "от 190 баллов – 30%",
              "от 211 балла – 40%",
              "от 231 балла – 50%",
            ],
            perspective: "Выпускники бакалавриата могут продолжить обучение в магистратуре, в том числе по индивидуальному графику совмещая учебу с работой специалистами банков и инвестиционных фондов, управляющими подразделений и специалистами государственных органов управления. Выпускники востребованы в крупных организациях агропромышленного комплекса, агрохолдингах, отечественных и иностранных компаниях, научно-исследовательских институтах."
          },
          // {
          //   name: "38.03.04\tГосударственное и муниципальное управление",
          //   budgetPlaces: 0,
          //   contractPlaces: 25,
          //   programs: ["Муниципальное управление"],
          //   price: "Стоимость обучения без предоставления скидки: 276 900 руб.",
          //   exams: [
          //     "Математика",
          //     "Обществознание или История или География или Информатика и ИКТ или Иностранный язык (английский)",
          //     "Русский язык",
          //   ],
          //   spoExams: ["Экономика организации", "Менеджмент", "Русский язык"],
          //   discounts: [
          //     "от 190 баллов – 30%",
          //     "от 211 балла – 40%",
          //     "от 231 балла – 50%",
          //   ],
          //   perspective: "Выпускники могут работать специалистами и руководителями в области государственного и муниципального управления, а также специалистами по государственному и муниципальному управлению в частных компаниях или неправительственных организациях, аналитиками в государственных или муниципальных органах, консультантами по вопросам государственного и муниципального управления в консалтинговых компаниях и общественных организациях.",
          // },
          {
            name: "42.03.01 Реклама и связи с общественностью",
            budgetPlaces: 0,
            contractPlaces: 90,
            programs: [
              "Реклама и медиакоммуникации",
            ],
            price: "Стоимость обучения без предоставления скидки: 312 500 руб.",
            exams: [
              "Обществознание",
              "История, Информатика и информационно-коммуникационные технологии (ИКТ) Иностранный язык (английский), Литература",
              "Русский язык"
            ],
            spoExams: ["Русский язык", "Экономика организации", "Менеджмент"],
            discounts: [
              "от 190 баллов – 30%",
              "от 211 балла – 40%",
              "от 231 балла – 50%",
            ],
            perspective: "Выпускники бакалавриата могут продолжить обучение в магистратуре, в том числе по индивидуальному графику совмещая учебу с работой, востребованы в крупных коммуникационных агентствах полного цикла, отделах по связям с общественностью в крупных компаниях и организациях, в пресс-службах и редакциях различных медиахолдингов."
          },
          // {
          //   name: "43.03.02 Туризм",
          //   budgetPlaces: 0,
          //   contractPlaces: 25,
          //   programs: ["Туризм и индустрия гостеприимства"],
          //   price: "Стоимость обучения без предоставления скидки: 276 900 руб.",
          //   exams: [
          //     "История",
          //     "География, Обществознание, Биология; Иностранный язык (английский)",
          //     "Русский язык"
          //   ],
          //   spoExams: ["Русский язык", "Психология", "Экономика организации"],
          //   discounts: [
          //     "от 190 баллов – 30%",
          //     "от 211 балла – 40%",
          //     "от 231 балла – 50%",
          //   ],
          //   perspective: "Выпускники бакалавриата могут продолжить обучение в магистратуре, в том числе по индивидуальному графику совмещая учебу с работой, востребованы в крупных агрохолдингах, отечественных и иностранных компаниях, малых формах бизнеса и в государственных органах.",
          // },
          {
            name: "44.03.04 Профессиональное обучение (по отраслям)",
            budgetPlaces: 0,
            contractPlaces: "60",
            programs: [
              "Экономика и управление",
              "Информационные системы и технологии",
            ],
            price: " Стоимость обучения без предоставления скидки: 312 500 руб.",
            exams: [
              "Математика",
              "Информатика и информационно-коммуникационные технологии (ИКТ), История, Обществознание, Физика, Химия, География, Иностранный язык (английский), Биология, Литература",
              "Русский язык",
            ],
            spoExams: ["Педагогика", "Психология", "Русский язык"],
            discounts: [
              "от 190 баллов – 30%",
              "от 211 балла – 40%",
              "от 231 балла – 50%",
            ],
            perspective: "Выпускники готовы к преподавательской деятельности по программам профессионального обучения, среднего профессионального образования и дополнительным профессиональным программам, востребованы в образовательных учреждениях, ресурсных центрах, компаниях по производству обучающего контента."
          },
        ],
      },
      {
        name: "Специалитет",
        directions: [
          {
            name: "38.05.01 Экономическая безопасность",
            budgetPlaces: 0,
            contractPlaces: "30 очная форма обучения / 30 очно-заочная форма обучения / 30 заочная форма обучения",
            programs: [
              "Экономико-правовое обеспечение экономической безопасности (очная и заочная формы)",
            ],
            price: "Стоимость обучения без предоставления скидки: 312 500 руб. (очная форма)/ 95 000 руб. (заочная форма)/ 110 000 руб. (очно-заочная форма).",
            exams: [
              "Математика",
              "Обществознание, История, Информатика и информационно-коммуникационные технологии (ИКТ)",
              "Русский язык",
            ],
            spoExams: ["Экономика организации", "Менеджмент", "Русский язык"],
            discounts: [
              "от 190 баллов – 30%",
              "от 211 балла – 40%",
              "от 231 балла – 50%",
            ],
            perspective: "Выпускники широко востребованы в отечественных и иностранных предприятиях в сельском хозяйстве, перерабатывающей промышленности и других отраслях экономики, банках, аудиторских компаниях. Выпускники данной программы специалитета также могут продолжить обучение в аспирантуре по научной специальности 5.2.3 Региональная и отраслевая экономика."
          },
        ],
      },
      {
        name: "Магистратура",
        directions: [
          {
            name: "09.04.02 Информационные системы и технологии",
            budgetPlaces: "28",
            contractPlaces: "10",
            programs: [
              "Науки о данных",
            ],
            price: "без предоставления скидки: 373 900 руб. (очная форма)",
            exams: [
              "09.04.02 Информационные системы и технологии",
            ],
            discounts: [
              "При сумме конкурсных баллов от 70 и выше – 35%",
            ],
            testForm: "бланковое или компьютерное тестирование Минимальное количество баллов для вступительных испытаний",
            perspective: "Выпускники магистратуры могут работать специалистами по работе с данными (Data Scientists), аналитиками данных (Data Analysts), специалистами по информационным системам (Information Systems Specialists), специалистами машинного обучения (Machine Learning Specialists), программистами, руководителями проектов. Выпускники магистратуры могут продолжить обучение в аспирантуре по направлению 2.3.8 Информатика и информационные процессы."
          },
          {
            name: "09.04.03 Прикладная информатика",
            budgetPlaces: 26,
            contractPlaces: 20,
            // budgetPlaces2: 20,
            // contractPlaces2: 15,
            programs: [
              "Архитектура систем искусственного интеллекта", 
              "ИТ-инновации и цифровые решения для бизнеса",
            ],
            // programs2: [
            //   "Архитектура систем искусственного интеллекта",
            // ],
            price: "без предоставления скидки: 373 900 руб. (очная форма)",
            exams: [
              "09.04.03 Прикладная информатика",
            ],
            discounts: [
              "При сумме конкурсных баллов от 70 и выше – 35%",
            ],
            testForm: "бланковое или компьютерное тестирование Минимальное количество баллов для вступительных испытаний",
            perspective: "Выпускник может претендовать на высококвалифицированные должности в области разработки и внедрения систем искусственного интеллекта, анализа данных и машинного обучения. Трудоустройство возможно в IT-компаниях, финансовых учреждениях, промышленных предприятиях, научно-исследовательских институтах, в области здравоохранения, в логистических и транспортных компаниях, в розничной торговле и электронной коммерции, в телекоммуникациях, а также в государственных органах управления и сфере обеспечения национальной безопасности. Кроме того, выпускник может заниматься разработкой интеллектуальных систем поддержки принятия решений, систем автоматизации бизнес-процессов, аналитических систем для работы с большими данными и проектированием архитектур ИИ для комплексных сервисных платформ. Есть возможности для продолжения научной деятельности, включая аспирантуру и докторантуру, с целью проведения исследований в области искусственного интеллекта и разработки новых технологий."
          },
          {
            name: "38.04.01 Экономика",
            budgetPlaces: "11 очная форма / 0 очно- заочная форма / 5 заочная форма",
            contractPlaces: "19 очная форма / 25 очно- заочная форма / 15 заочная форма",
            budgetPlaces2: "11 очная форма / 5 заочная форма",
            contractPlaces2: "19 очная форма / 15 заочная форма",
            programs: [
              "Экономика устойчивого развития и ESG -трансформация бизнеса",
              
            ],
            programs2: [
              "Оценка бизнеса, корпоративный учет и финансы в цифровой экономике",
            ],
            price: "без предоставления скидки: 339 000 руб. (очная форма)/ 120 000 руб. (очно-заочная форма), 110 000 руб. (заочная форма).",
            exams: [
              "Комплексный экзамен по направлению подготовки: 38.04.01 Экономика"
            ],
            discounts: [
              "При сумме конкурсных баллов от 70 и выше – 35%",
            ],
            testForm: "бланковое или компьютерное тестирование Минимальное количество баллов для вступительных испытаний 30 баллов.",
            perspective: "Перспективы трудоустройства, профессиональной и/или научной деятельности. Руководители организаций, заместители руководителей по экономическим вопросам и инновационному развитию, ведущие специалисты в государственных учреждениях, организациях АПК, высшие учебные заведения. Возможные профессии, сферы деятельности: экономические, финансовые, маркетинговые, производственно-экономические и аналитические службы организаций различных отраслей, сфер и форм собственности, органы государственной и муниципальной власти, академические и ведомственные научно-исследовательские организации, учреждения высшего профессионального образования."
          },
          {
            name: "38.04.02 Менеджмент",
            budgetPlaces: "9 заочная форма",
            contractPlaces: "11 заочная форма",
            budgetPlaces2: "0 очная форма",
            contractPlaces2: "20 очная форма",
            programs: [
              "Управление бизнес-процессами в АПК",
            ],
            programs2: [
              "Управление цепями поставок в цифровой экономике",
            ],
            price: "без предоставления скидки: 339 000 руб. (очная форма)/ 110 000 руб. (заочная форма).",
            exams: [
              "38.04.02 Менеджмент",
            ],
            discounts: [
              "При сумме конкурсных баллов от 70 и выше – 35% ",
            ],
            testForm: "бланковое или компьютерное тестирование Минимальное количество баллов для вступительных испытаний",
            perspective: "Выпускники магистратуры имеют возможность продолжить обучение в аспирантуре. Выпускники работают специалистами банков и инвестиционных фондов, управляющими подразделений и специалистами государственных органов управления; востребованы в крупных агрохолдингах, научно-исследовательских организациях."
          },
          {
            name: "44.04.04 Профессиональное обучение (по отраслям)",
            budgetPlaces: "45 очная форма / 29 заочная форма",
            contractPlaces: "5 очная форма / 15 заочная форма",
            programs: [
              "Цифровая образовательная среда и цифровые технологии",
            ],
            price: "без предоставления скидки: 339 000 руб. (очная форма)/ 110 000 руб. (заочная форма).",
            exams: [
              "44.04.04 Профессиональное обучение",
            ],
            discounts: [
              "При сумме конкурсных баллов от 70 и выше – 35%",
            ],
            testForm: "бланковое или компьютерное тестирование Минимальное количество баллов для вступительных испытаний",
            perspective: "Выпускники по данной программе магистратуры востребованы в образовательных организациях разного уровня, а также в методических и ресурсных центрах, организациях дополнительного профессионального образования, научно-исследовательских институтах, учебно-курсовых комбинатах и производственных предприятиях. Выпускники программы магистратуры также могут продолжить обучение в аспирантуре по научной специальности 5.8.7 Методология и технология профессионального образования."
          },
          {
            name: "38.04.04 Государственное и муниципальное управление",
            budgetPlaces: "0 очная форма / 10 заочная форма",
            contractPlaces: "25 очная форма / 16 заочная форма",
            programs: [
              "Государственная служба",
            ],
            price: "без предоставления скидки: 339 000 руб. (очная форма)/ 110 000 руб. (заочная форма).",
            exams: [
              "38.04.04 Государственное и муниципальное управление",
            ],
            discounts: [
              "При сумме конкурсных баллов от 70 и выше – 35%",
            ],
            testForm: "бланковое или компьютерное тестирование Минимальное количество баллов для вступительных испытаний",
            perspective: "Выпускники магистратуры имеют возможность продолжить обучение в аспирантуре. Выпускники работают специалистами сферы публичного управления, системы государственного и муниципального управления, менеджерами организаций, взаимодействующих с органами государственного и муниципального управления."
          },
          // {
          //   name: "42.04.01 Реклама и связи с общественностью",
          //   budgetPlaces: "0",
          //   contractPlaces: "15",
          //   programs: [
          //     "Реклама и медиакоммуникации в цифровой среде",
          //   ],
          //   price: "297 400",
          //   exams: [
          //     "42.04.01 Реклама и связи с общественностью",
          //   ],
          //   discounts: [
          //     "от 70 баллов – 35%",
          //   ],
          //   testForm: "Конкурсный отбор (портфолио)",
          //   perspective: "Выпускники магистратуры востребованы в крупных коммуникационных агентствах полного цикла, отделах по связям с общественностью в крупных компаниях и организациях, в пресс-службах и редакциях различных медиахолдингов."
          // },
        ],
      },
    ],
  }),
  methods: {
    chooseGrade(gradeName : string) {
      this.choosedCard = -1
      this.choosedGrade = gradeName
    },
    changeState(index : number) {
      if (this.choosedCard === index) {
        this.choosedCard = -1
      }
      else {
        this.choosedCard = index
      }
    }
  },
  components: { ExtensionCard },
});
